module.exports = __webpack_public_path__ + "img/customer-a-038.4de75cf2.png";